<template>
  <v-dialog v-model="showDialog" max-width="300">
      <v-card>
        <v-card-title>
          <span v-text="title"></span>
          <v-spacer />
          <v-icon aria-label="Close" @click="showDialog=false">mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text class="pb-6 pt-12 text-center" v-text="message">
        </v-card-text>
        <slot name="message"></slot>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-3" text  @click="$emit('update:confirmDialog', false)"  v-text="noButtonText">
            No
          </v-btn>
          <v-btn  color="error" text @click="yesAction" v-text="yesButtonText">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "Please confirm"
    },
    message: {
      type: String,
      default: "Are you sure?"
    },
    yesButtonText: {
      type: String,
      default: "Yes"
    },
    noButtonText: {
      type: String,
      default: "No"
    },
    showDialog: {
      type: Boolean,
      default: false
    },
    yesAction: {
      type: Function,
      default: undefined
    }
  }
}
</script>